"use client";

import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinancialAssessment() {
  return <section id="financialassessmentcta" data-nav="light" className="bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-[1240px] px-4 sm:px-6 md:px-8">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-50px"
      }} transition={{
        duration: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }} className="rounded-xl border border-border bg-card p-8 sm:p-10 md:p-12 shadow-sm text-center max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight text-foreground font-default">
            Not Sure Where to Start?
          </h2>

          <div className="mt-4 space-y-3 sm:space-y-4 text-muted-foreground text-base sm:text-lg leading-relaxed">
            <p>
              Your financial life may involve several connected decisions. The
              Financial Assessment helps you take a broader look at areas such as
              protection, retirement income, financial priorities, and legacy
              considerations.
            </p>
            <p>
              Before you begin, you&apos;ll see an overview explaining what the
              assessment reviews, what to expect, and its limitations. You can
              then choose whether you want to continue.
            </p>
          </div>

          <div className="mt-8 flex flex-col items-center">
            <motion.div whileHover={{
            y: -1.5
          }} transition={{
            duration: 0.18,
            ease: "easeOut"
          }}>
              <Button asChild size="lg" className="font-medium px-6 sm:px-8 h-12 text-base rounded-md">
                <Link href="https://www.altavidacapital.com/financial-assessment-overview/" target="_blank" rel="noopener noreferrer">
                  Explore the Financial Assessment
                </Link>
              </Button>
            </motion.div>

            <p className="mt-4 max-w-xl text-xs sm:text-sm text-muted-foreground leading-normal">
              The Financial Assessment is provided through AltaVida Capital, our
              educational resource platform. You&apos;ll be taken to AltaVida Capital
              to review the assessment before deciding whether to begin.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}